import { render, staticRenderFns } from "./ThgPriceOverview.vue?vue&type=template&id=3aa43766"
import script from "./ThgPriceOverview.vue?vue&type=script&lang=ts"
export * from "./ThgPriceOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports